import {Injectable} from '@angular/core';

@Injectable()
export class StorageService {
  // static getItem(key: any) {
  //   // @ts-ignore
  //   return localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : null;
  //   console.log(localStorage.getItem(key));
  // }

  static getItem(key: string) {
    const rawValue = localStorage.getItem(key);

    if (!rawValue || rawValue === "undefined") {
      return null;
    }

    try {
      return JSON.parse(rawValue);
    } catch (e) {
      console.error(`Error parsing localStorage key "${key}":`, e);
      return rawValue; // return as plain string if not valid JSON
    }
  }


  static setItem(key: any, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  static removeItem(key: any) {
    localStorage.removeItem(key);
  }

  static clearAll() {
    localStorage.clear();
  }

  static setUserToken(token: any, tokenType: any) {
    localStorage.setItem('token', token);
    localStorage.setItem('tokenType', tokenType);
  }

  constructor() {
  }

  public setUser(user: any) {
    localStorage.setItem('user', user);
  }
}
